module.exports = __webpack_public_path__ + "static/PUNTO-1-ef2da7f6be9da91dca5a4ef2d15003e1.png";